module.exports = __webpack_public_path__ + "img/question-mark.26848f74.png";